<div class="bg-img-circule">
  <img src="../../../../assets/images/Home-2.png" />
</div>
<app-menu-template1>
  <main>
    <article class="row ml-5 mr-5">
      <section class="col-12 rounded p-5 mt-4 shadow bg-white">
        <h1 class="h4 mb-2 d-flex justify-content-center mb-5">
          Consulta de RNT
        </h1>
        <div class="card mb-3 mt-2">
          <div class="card-body">
            <p class="small text-secondary font-weight-bold">
              *Recuerde incluir por lo menos un criterio de búsqueda para
              habilitar el botón de consulta.
            </p>
            <form [formGroup]="filtro" (ngSubmit)="enviarForm()">
              <div class="row">
                <!-- <div class="col-2 form-group">
                  <label class="small text-secondary mb-0" for="codigo_camara">Cámara de Comercio</label>
                  <select class="form-control form-control-sm" id="codigo_camara" formControlName="codigo_camara">
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option class="" *ngFor="let option of camarasLista; let i = index" value="{{option?.codigo_camara}}"
                      [selected]="false">
                      {{option?.desc_camara}}
                    </option>
                  </select>
                </div> -->
                <ng-container formGroupName="filtroGroup">
                  <div class="col-sm-12 col-md-3 form-group">
                    <label class="small text-secondary mb-0" for="codigo_rnt"
                      >Número RNT</label
                    >
                    <input
                      id="codigo_rnt"
                      type="text"
                      class="form-control form-control-sm"
                      formControlName="codigo_rnt"
                    />
                    <div
                      id="mensaje"
                      *ngIf="
                        !filtro.get('filtroGroup').get('codigo_rnt').valid &&
                        filtro.get('filtroGroup').get('codigo_rnt').dirty
                      "
                    >
                      <p
                        class="small text-danger mt-1 position-absolute font-weight-bold"
                        text-right
                      >
                        Dígite únicamente valores numéricos
                      </p>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-3 form-group">
                    <label class="small text-secondary mb-0" for="nit"
                      >Nit</label
                    >
                    <input
                      id="nit"
                      type="text"
                      class="form-control form-control-sm"
                      formControlName="nit"
                    />
                  </div>
                  <div class="col-sm-12 col-md-3 form-group">
                    <label
                      class="small text-secondary mb-0"
                      for="establecimiento"
                      >Nombre establecimiento</label
                    >
                    <input
                      id="establecimiento"
                      type="text"
                      class="form-control form-control-sm"
                      formControlName="establecimiento"
                    />
                  </div>
                </ng-container>
                <div class="col-sm-12 col-md-3 g-recaptcha">
                  <re-captcha
                    formControlName="captcha"
                    class="d-inline-block"
                  ></re-captcha>
                </div>
              </div>
              <div class="row form-row">
                <div class="col-md-3 col-sm-12"></div>
                <div class="col-md-3 col-sm-12 text-center">
                  <button
                    class="btn btn-primary m-auto solicitud-btn-principal w-100"
                    type="submit"
                    [disabled]="!filtro.valid"
                  >
                    Consultar
                  </button>
                </div>
                <div class="col-md-3 col-sm-12 text-center">
                  <button
                    type="reset"
                    class="btn btn-outline-primary border-0 m-auto w-100"
                    (click)="limpiar()"
                  >
                    Limpiar
                  </button>
                </div>
                <div class="col-md-3 col-sm-12"></div>
              </div>
            </form>
          </div>
        </div>
        <app-tablas
          [page]="paginaActual"
          [headers]="headersRnt"
          [sizeData]="dataTabla.paging.totalItems"
          class="table-responsive"
          (paginado)="onPaginado($event)"
          *ngIf="dataTabla.paging.totalItems >= 1"
        >
          <tr *ngFor="let item of dataTabla.items; let i = index" class="small">
            <td>{{ item.codigo_rnt }}</td>
            <td>{{ item.nit }}</td>
            <td>{{ item.descripcion_tipo_rnt }}</td>
            <td>{{ item.razon_social }}</td>
            <td>{{ item.descripcion_camara }}</td>
            <td>{{ item.direccion_comercial }}</td>
            <td>{{ item.descripcion_tipo_establecimiento }}</td>
            <td>
              {{
                item.fecha_inscripcion == "0001-01-01T00:00:00"
                  ? ""
                  : (item.fecha_inscripcion | date: "d/MMM/yyyy")
              }}
            </td>
            <td>
              {{
                item.fecha_ultima_renovacion == "0001-01-01T00:00:00"
                  ? ""
                  : (item.fecha_ultima_renovacion | date: "yyyy")
              }}
            </td>
            <td>{{ item.descripcion_estado_rnt }}</td>
            <td>
              <ng-container *ngIf="item.sanciones; else no_data_sanciones">
                <a
                  class="text-black-item pointer"
                  id="sanciones"
                  (click)="descargarDocumento(item.sanciones[0])"
                  >{{ item.sanciones[0].titulo }}
                </a>
                <div ngbDropdown *ngIf="item.sanciones.length - 1 > 0">
                  <a
                    class="text-decoration-none text-secondary pointer"
                    id="sanciones"
                    ngbDropdownToggle
                    >+ {{ item.sanciones.length - 1 }}
                    {{
                      item.sanciones.length - 1 == 1 ? "sanción" : "sanciones"
                    }}
                    más</a
                  >
                  <div
                    ngbDropdownMenu
                    aria-labelledby="sanciones"
                    class="order-div px-2"
                  >
                    <button
                      class="dropdown-item px-0"
                      (click)="descargarDocumento(itemSancion)"
                      *ngFor="
                        let itemSancion of item.sanciones | slice: 1;
                        let i = index
                      "
                    >
                      {{ itemSancion.titulo }}
                    </button>
                  </div>
                </div>
              </ng-container>
              <ng-template #no_data_sanciones>No tiene sanciones</ng-template>
            </td>
          </tr>
        </app-tablas>
      </section>
    </article>
  </main>
</app-menu-template1>
